import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { GRPCEnvironment } from './class/environment.class';
import { GRPC_ENVIRONMENT, GRPCEnvironmentProvider } from './providers/environment.provider';
import { LocalizationGrpcContractProvider } from './providers/localization.service.provider';
import { HeaderService } from './services/header.service';
import { LocalizationGrpcContractService } from './services/localization.service';

export function provideGrpcConfig<T extends GRPCEnvironment>(environment: T): EnvironmentProviders {
  return makeEnvironmentProviders([
    GRPCEnvironmentProvider,
    LocalizationGrpcContractProvider,

    LocalizationGrpcContractService,
    HeaderService,
    {
      provide: GRPC_ENVIRONMENT,
      useValue: environment,
    },
  ]);
}
